import React from "react";

export default (props) => (
    <span className="btn btn-sm border rounded" {...props}>
        <i className="fa fa-ellipsis-h" />
    </span>
);
